/*
 * Voucher hunt (server-side codes). The page carries NO code and NO schedule —
 * only the endpoint (window.GTVoucherHunt). On load this asks the mailer Apps
 * Script, by JSONP, which pages have a gift today (Cairo) — amounts only, never
 * codes — and caches that for the day. The real code is fetched (base64, keyed)
 * only when the gift is clicked, so a scrape or "read this page" AI finds nothing
 * redeemable in the source. The code is still exposed at redemption time (it has
 * to go into /discount/CODE); the Shopify discount's own cap/min/expiry are the
 * real limit. Obfuscation here (short actions, base64 payload) is a speed bump,
 * not security.
 */
(function () {
  var cfg = window.GTVoucherHunt;
  if (!cfg || !cfg.url || !window.fetch || !document.body) return;
  var AR = cfg.lang === 'ar';

  // Today's date in Cairo (YYYY-MM-DD), so the campaign flips at Egyptian midnight.
  var day;
  try {
    day = new Intl.DateTimeFormat('en-CA', { timeZone: 'Africa/Cairo', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
  } catch (e) { day = new Date().toISOString().slice(0, 10); }

  // Path as the sheet stores it (locale prefix stripped), matching voucher-hunt.liquid's old logic.
  function here() {
    var p = location.pathname, root = cfg.root || '/';
    if (root !== '/' && p.indexOf(root) === 0) { p = p.slice(root.length); if (p.charAt(0) !== '/') p = '/' + p; }
    return p || '/';
  }
  var path = here();

  // --- JSONP (Apps Script answers cross-origin; a plain fetch cannot read it) ---
  function callOnce(params, done) {
    var name = 'gv' + Math.random().toString(36).slice(2, 9);
    var s = document.createElement('script');
    var q = ['cb=' + name];
    for (var k in params) if (k !== 'cb') q.push(encodeURIComponent(k) + '=' + encodeURIComponent(params[k]));
    var settled = false;
    function settle(data) {
      if (settled) return; settled = true;
      if (s.parentNode) s.parentNode.removeChild(s);
      // Keep window[name] defined (as a no-op) for a while: a slow/retried Apps Script
      // reply can arrive after we've moved on, and if the name were gone it would log
      // "Uncaught ReferenceError: <cb> is not defined". Drop it later, once no reply can come.
      setTimeout(function () { try { delete window[name]; } catch (e) { window[name] = void 0; } }, 60000);
      try { done(data); } catch (e) {}
    }
    window[name] = function (data) { settle(data); };
    s.onerror = function () { settle(null); };
    s.src = cfg.url + '?' + q.join('&');
    document.head.appendChild(s);
    setTimeout(function () { settle(null); }, 10000);
  }
  // Apps Script GET occasionally returns an interstitial instead of the JS; retry a couple of times.
  function call(params, done, tries) {
    tries = tries || 3;
    callOnce(params, function (data) {
      if (data == null && tries > 1) { setTimeout(function () { call(params, done, tries - 1); }, 700); return; }
      done(data);
    });
  }

  // Today's gift list (paths + amounts, no codes), cached per day so it is one call per visitor per day.
  function todayList(done) {
    var key = 'gt:vh:' + day, cached;
    try { cached = JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { cached = null; }
    if (cached) return done(cached);
    call({ action: 'vd', d: day }, function (res) {
      var items = (res && res.ok && res.items) || [];
      try {
        localStorage.removeItem('gt:vh:' + new Date(Date.now() - 86400000).toISOString().slice(0, 10));
        localStorage.setItem(key, JSON.stringify(items));
      } catch (e) {}
      done(items);
    });
  }

  todayList(function (items) {
    var mine = null;
    for (var i = 0; i < items.length; i++) { if (items[i] && items[i].p === path) { mine = items[i]; break; } }
    if (!mine) return;
    build(mine);
  });

  // --- UI ---
  function fmt(n) { return Number(n).toLocaleString('en-US'); }

  function build(item) {
    var t = AR ? {
      hint: 'كوبون مستخبي', title: 'مبروك! لقيت الكوبون 🎉',
      off: item.a ? 'خصم ' + fmt(item.a) + ' جنيه' : 'خصم خاص',
      min: item.m ? 'على الطلبات من ' + fmt(item.m) + ' جنيه' : '',
      terms: 'لأول ' + cfg.uses + ' شخص بس · مرة واحدة لكل عميل · صالح النهارده',
      copy: 'انسخ الكود', copied: 'اتنسخ ✓', apply: 'استخدمه في طلبي', close: 'إغلاق',
      loading: 'لحظة…', gone: 'الكوبون خلص للأسف'
    } : {
      hint: 'Hidden voucher', title: 'You found the voucher! 🎉',
      off: item.a ? fmt(item.a) + ' EGP off' : 'Special discount',
      min: item.m ? 'on orders from ' + fmt(item.m) + ' EGP' : '',
      terms: 'First ' + cfg.uses + ' people only · once per customer · valid today',
      copy: 'Copy code', copied: 'Copied ✓', apply: 'Use it on my order', close: 'Close',
      loading: 'One moment…', gone: 'Sorry, this voucher is gone'
    };

    var css = document.createElement('style');
    css.textContent =
      '.vh-gift{position:absolute;z-index:5;width:44px;height:44px;border:0;border-radius:50%;padding:0;cursor:pointer;' +
      'background:#FFCE00;box-shadow:0 6px 16px rgba(7,27,77,.35);font-size:24px;line-height:44px;text-align:center;' +
      'animation:vh-wiggle 3.2s ease-in-out infinite}' +
      '.vh-gift:focus-visible{outline:3px solid #155EEF;outline-offset:3px}' +
      '@keyframes vh-wiggle{0%,86%,100%{transform:rotate(0)}89%{transform:rotate(-14deg)}93%{transform:rotate(12deg)}96%{transform:rotate(-6deg)}}' +
      '@media (prefers-reduced-motion:reduce){.vh-gift{animation:none}}' +
      '.vh-dialog{border:0;border-radius:24px;padding:0;max-width:min(92vw,400px);width:100%;background:#fff;color:#071B4D;' +
      'box-shadow:0 30px 80px rgba(0,0,0,.35);font-family:inherit}' +
      '.vh-dialog::backdrop{background:rgba(7,27,77,.55)}' +
      '.vh-top{background:linear-gradient(135deg,#071B4D,#155EEF);color:#fff;padding:28px 24px 22px;text-align:center}' +
      '.vh-top b{display:block;font-size:22px;margin-bottom:6px}.vh-top span{font-size:30px;font-weight:800;color:#FFCE00}' +
      '.vh-top small{display:block;font-size:14px;opacity:.9;margin-top:2px}' +
      '.vh-body{padding:20px 22px 22px;display:grid;gap:12px;text-align:center}' +
      '.vh-code{font:700 26px/1 ui-monospace,Menlo,monospace;letter-spacing:2px;border:2px dashed #155EEF;border-radius:14px;padding:14px;direction:ltr;user-select:all;background:#f5f7fc;min-height:26px}' +
      '.vh-terms{font-size:13px;color:#55627f}' +
      '.vh-btns{display:grid;grid-template-columns:1fr 1fr;gap:10px}' +
      '.vh-btns a,.vh-btns button{min-height:46px;border-radius:99px;font-family:inherit;font-weight:700;font-size:15px;line-height:1.2;display:flex;align-items:center;justify-content:center;cursor:pointer;text-decoration:none}' +
      '.vh-btns a[aria-disabled=true]{opacity:.5;pointer-events:none}' +
      '.vh-copy{background:#fff;color:#071B4D;border:2px solid #071B4D}.vh-apply{background:#FFCE00;color:#071B4D;border:0}' +
      '.vh-close{position:absolute;top:10px;inset-inline-end:12px;background:none;border:0;color:#fff;font-size:26px;cursor:pointer;width:40px;height:40px}' +
      'html[data-theme=dark] .vh-dialog{background:#0d1733;color:#e8edf9}html[data-theme=dark] .vh-code{background:#13224a;border-color:#5b8cff}' +
      'html[data-theme=dark] .vh-copy{background:transparent;color:#e8edf9;border-color:#e8edf9}html[data-theme=dark] .vh-terms{color:#9aa6c4}';
    document.head.appendChild(css);

    var dialog = document.createElement('dialog');
    dialog.className = 'vh-dialog';
    dialog.setAttribute('dir', AR ? 'rtl' : 'ltr');
    dialog.innerHTML =
      '<div class="vh-top"><button type="button" class="vh-close" aria-label="' + t.close + '">×</button>' +
      '<b>' + t.title + '</b><span>' + t.off + '</span><small>' + t.min + '</small></div>' +
      '<div class="vh-body"><div class="vh-code">' + t.loading + '</div><div class="vh-terms">' + t.terms + '</div>' +
      '<div class="vh-btns"><button type="button" class="vh-copy" disabled>' + t.copy + '</button>' +
      '<a class="vh-apply" aria-disabled="true" href="#">' + t.apply + '</a></div></div>';
    document.body.appendChild(dialog);

    var codeEl = dialog.querySelector('.vh-code');
    var copyBtn = dialog.querySelector('.vh-copy');
    var applyBtn = dialog.querySelector('.vh-apply');
    var close = function () { dialog.close ? dialog.close() : dialog.removeAttribute('open'); };
    dialog.querySelector('.vh-close').addEventListener('click', close);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    copyBtn.addEventListener('click', function () {
      var code = codeEl.textContent;
      if (!code) return;
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () { copyBtn.textContent = t.copied; }, function () {});
      try { var r = document.createRange(); r.selectNodeContents(codeEl); var sel = getSelection(); sel.removeAllRanges(); sel.addRange(r); } catch (e) {}
    });

    // The code is fetched only now, on the real click — once per opening.
    var fetched = false;
    function reveal() {
      if (fetched) return; fetched = true;
      call({ action: 'vg', d: day, p: path, k: cfg.key || '' }, function (res) {
        var code = '';
        try { if (res && res.ok && res.c) code = decodeURIComponent(escape(atob(res.c))); } catch (e) { code = ''; }
        if (!code) { codeEl.textContent = t.gone; fetched = false; return; }  // allow a retry on next open
        codeEl.textContent = code;
        copyBtn.disabled = false;
        var back = location.pathname + location.search;
        applyBtn.setAttribute('href', (cfg.root === '/' || !cfg.root ? '' : cfg.root.replace(/\/$/, '')) + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back));
        applyBtn.setAttribute('aria-disabled', 'false');
      });
    }

    // Place the gift at a spot derived from path+date, so it is stable per day but differs.
    var main = document.getElementById('MainContent') || document.body;
    if (getComputedStyle(main).position === 'static') main.style.position = 'relative';
    var seed = path + '|' + day, hash = 0;
    for (var i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
    var gift = document.createElement('button');
    gift.type = 'button';
    gift.className = 'vh-gift';
    gift.setAttribute('aria-label', t.hint);
    gift.textContent = '🎁';
    var place = function () {
      var h = Math.max(main.scrollHeight - 160, 400);
      gift.style.top = Math.round(260 + (hash % 1000) / 1000 * (h - 260)) + 'px';
      gift.style.left = (6 + ((hash >>> 10) % 82)) + '%';
    };
    place();
    window.addEventListener('load', place);
    main.appendChild(gift);
    gift.addEventListener('click', function () {
      reveal();
      dialog.showModal ? dialog.showModal() : dialog.setAttribute('open', '');
    });
  }
})();
